import { toPairs } from 'ramda';
import * as AppActionTypes from '../../store/app/types';
import { NoticesDetails } from '../../modules/settings/store/types';
import { BookingDetails } from '../../modules/booking/store/types';
import { matchHead } from '../../utility';
import { fromPairs } from 'ramda';
import { InvoiceList } from '../../modules/accounting/store/types';
import { GlobalActionFlags } from '../../store/global';

/**
 Automatically implements the mutation of the SET Nav Tab Details Mutation 
 * @param  {} DetailsAction=NoticesDetails
 * @param  {} detailsObjectKey='invoiceDetails'
 */
export const implementSetAllNavTabDetailsMutation = (DetailsAction, detailsObjectKey) => {
  return {
    [DetailsAction.SET.ALL](state, payload) {
      state[detailsObjectKey] = payload;
    }
  }
}
/**
 * Implements the SetNavTabDetails Action. Takes the routes, getterkey and the TabObjectCreation Function (For Side Tab bar UI)
 * @param  {NoticesDetails} DetailsAction=NoticesDetails
 * @param  {string} moduleRoute='booking'
 * @param  {string} childRoute='booking_list'
 * @param  {string} getterKey='bookingDetails'
 * @param  {createTabObject} createTabObjectFunc=createTabObject
 */
export const implementSetAllNavTabDetailsAction = (
  DetailsAction = NoticesDetails,
  moduleRoute = 'booking',
  childRoute = 'booking_list',
  getterKey = 'bookingDetails',
  createTabObjectFunc = createTabObject,
) => {
  return {
    async [DetailsAction.SET.ALL]({ commit, getters, rootState }, payload) {
      // Setting the Nav Tab Details Object
      commit(DetailsAction.SET.ALL, payload);
      // Setting Navigation Tabs
      setNavigationTabs(commit, rootState, moduleRoute, childRoute, getTabsFromDetailsDict(getters?.[getterKey], createTabObjectFunc));
    }
  }
}

/**
 * Implements the Delete Nav Tab Details Action
 * @param  {NoticesDetails} DetailsAction=NoticesDetails
 * @param  {string} getterKey='bookingDetails'
 * @param  {string} primaryKey='calendar_date_id'
 * @param  {string} fullRouteName='booking_list/calendar_date_id/tab'
 * @param  {string} listRouteName='booking_list'
 * @param  {() => {}} getRouter=getRouter
 */
export const implementDeleteNavTabAction = (
  DetailsAction = NoticesDetails,
  getterKey = 'bookingDetails',
  primaryKey = 'calendar_date_id',
  fullRouteName = 'booking_list/calendar_date_id/tab',
  listRouteName = 'booking_list',
  getRouter = () => { }
) => {
  return {

    // Do not use this function, use the implemented function in the NavTab module below.

    [DetailsAction.DELETE.SINGLE]: async ({ dispatch, getters }, payload) => {
      const primaryKeyValue = payload[primaryKey];

      dispatch(DetailsAction.SET.ALL, {
        ...getters[getterKey],
        [primaryKeyValue]: undefined
      });
      let router = getRouter();
      if (matchHead(fullRouteName, router.currentRoute.name)) {
        if (router.currentRoute.params[primaryKey] == primaryKeyValue) {
          router.push({
            name: listRouteName
          });
        }
      }
    }
  }
}
/**
 * Implements the Action of Setting a Single Keyvalue or Entry of Nav Tab Details Object 
 * @param  {NoticesDetails} DetailsAction=NoticesDetails
 * @param  {string} detailsGetterKey='bookingDetails'
 */
export const implementSetSingleNavTabDetailsAction = (DetailsAction = NoticesDetails, detailsGetterKey = 'bookingDetails') => {
  return {
    async [DetailsAction.SET.SINGLE]({ getters, dispatch }, payload) {
      const { primaryKeyValue, update } = payload;
      dispatch(DetailsAction.SET.ALL, {
        ...getters[detailsGetterKey],
        [primaryKeyValue]: {
          ...getters[detailsGetterKey][primaryKeyValue],
          ...update
        },
      });
    },
  }
}

const NAV_TAB_DATE = 'NAV_TAB_DATE';
function actionExists(store, actionName) {
  const actions = store._actions || {};
  return Object.hasOwnProperty.call(actions, actionName);
}
/**
 * Update a Single Nav Tab Details Object
 * @param {NoticesDetails} DetailsAction - The details action
 * @param {string} detailsGetterKey - The details getter key
 * @param {Object} optionalArguments - The optional arguments
 * @param {InvoiceList} optionalArguments.ListAction - The list actions
 */
export const getNavTabModule = (DetailsAction = NoticesDetails, detailsGetterKey = 'invoiceDetails', optionalArguments = {
  ListAction: InvoiceList
}) => {
  /**
   * Implements the Delete Nav Tab Details Action
   * @param  {string} primaryKey='calendar_date_id'
   * @param  {string} fullRouteName='booking_list/calendar_date_id/tab'
   * @param  {string} listRouteName='booking_list'
   * @param  {() => {}} getRouter=getRouter
   */
  const implementDeleteNavTabAction = (
    primaryKey = 'calendar_date_id',
    fullRouteName = 'booking_list/calendar_date_id/tab',
    listRouteName = 'booking_list',
    getRouter = () => { }
  ) => {
    console.log(`implementDeleteNavTabAction called with primaryKey: ${primaryKey}, fullRouteName: ${fullRouteName}, listRouteName: ${listRouteName}`);
    return {
      [DetailsAction.DELETE.SINGLE]: async ({ dispatch, getters }, payload) => {
        const primaryKeyValue = payload[primaryKey];

        console.log('Deleting pkv', primaryKey, primaryKeyValue);

        dispatch(DetailsAction.SET.ALL, {
          ...getters[detailsGetterKey],
          [primaryKeyValue]: undefined
        });


        // If optionalArguments.ListAction is provided, then delete the item from the list

        if (optionalArguments.ListAction) {
          dispatch(optionalArguments.ListAction.DELETE.SINGLE, {
            [primaryKey]: primaryKeyValue,
            [GlobalActionFlags.noDatabaseUpdate]: true
          });
        }

        const router = getRouter();
        if (matchHead(fullRouteName, router.currentRoute.name)) {
          if (router.currentRoute.params[primaryKey] === primaryKeyValue) {
            router.push({
              name: listRouteName
            });
          }
        }
      }
    }
  };

  /**
   * Implements the SetNavTabDetails Action. Takes the routes, getterkey and the TabObjectCreation Function (For Side Tab bar UI)
   * @param  {string} moduleRoute='booking'
   * @param  {string} childRoute='booking_list'
   * @param  {createTabObject} createTabObjectFunc=createTabObject
   */
  const implementSetAllNavTabDetailsAction = (
    moduleRoute = 'booking',
    childRoute = 'booking_list',
    createTabObjectFunc = createTabObject,
  ) => {
    return {
      async [DetailsAction.SET.ALL]({ commit, getters, rootState }, payload) {
        // Setting the Nav Tab Details Object
        commit(DetailsAction.SET.ALL, payload);
        // Setting Navigation Tabs
        setNavigationTabs(commit, rootState, moduleRoute, childRoute, getTabsFromDetailsDict(getters?.[detailsGetterKey], createTabObjectFunc));
      }
    }
  };
  /**
   * @param  {string} primaryKey='invoice_id'
   * @param  {string} fullRouteName='invoices/invoice_id/tab'
   * @param  {string} listRouteName='invoices'
   * @param  {() => {}} getRouter=getRouter
   * @param  {string} moduleRoute='accounting'
   * @param  {createTabObject} createTabObjectFunc=createTabObject
   */
  const implementActions = (
    primaryKey = 'invoice_id',
    fullRouteName = 'invoices/invoice_id/tab',
    listRouteName = 'invoices',
    getRouter = () => { },
    moduleRoute = 'accounting',
    createTabObjectFunc = createTabObject,
  ) => {
    return {
      ...implementDeleteNavTabAction(primaryKey, fullRouteName, listRouteName, getRouter),
      ...implementSetAllNavTabDetailsAction(moduleRoute, listRouteName, createTabObjectFunc),
    }
  };

  return {
    /**
    * @param  {Function} dispatch=(string, payload)=>{}
    * @param  {Object} getters={}
    */
    Helper: (dispatch = () => { }, getters = {}) => {
      /**
       * Find the Single NavTabDetails by the Primary Key Value and then Update it by the Update Function (the original Object is passed as the first argument)
       * @param  {string} primaryKeyValue='123'
       * @param  {(original)=>update} updateFunc=(original)=>update
       */
      const updateSingleNavTabDetails = (primaryKeyValue, updateFunc = (() => { })) => {
        // console.log(getters[detailsGetterKey][primaryKeyValue]);
        // console.log('Updating', {
        //   detailsGetterKey,
        //   primaryKeyValue,
        //   'getters[detailsGetterKey]': getters[detailsGetterKey],
        //   'getters[detailsGetterKey][primaryKeyValue]': getters[detailsGetterKey][primaryKeyValue],
        // });
        if (getters?.[detailsGetterKey]?.[primaryKeyValue]) {
          dispatch(DetailsAction.SET.ALL, {
            ...getters[detailsGetterKey],
            [primaryKeyValue]: {
              ...getters[detailsGetterKey][primaryKeyValue],
              ...updateFunc(getters[detailsGetterKey][primaryKeyValue]),
            },
          });
        }
      }

      /**
       * @typedef {Object} PathParams
       * @property {string} path - The path to the property to update.
       * @property {string} name - The name of the property to update.
       * @property {*} value - The new value for the property.
       * @property {Array.<Array.<string>>} nvps - An array of name-value pairs to update.
       * @property {string} primaryKey - The primary key to use when updating an array.
       * @property {*} kVal - The value of the primary key for the object to update in an array.
       * @property {Boolean} noDatabaseUpdate - The value of the primary key for the object to update in an array. */

      /**
       * Find the Single NavTabDetails by the Primary Key Value and then Update it by the Update Function (the original Object is passed as the first argument)
       * @param  {string} primaryKeyValue='123'
       * @param  {PathParams} pathParams
       * @param  {Function|Promise} databaseUpdateFuntion - The 'databaseUpdateFuntion' parameter is required. It's the third Parameter. For example:
          ```javascript
          async () => {
            await Service.api(payload);
          }
          ```
          Please provide a function, even if it's empty Like this -
DetailsAction.SET.ALL
          ```javascript
          async () => {}
          ```

          An Example in Production Code - 

          ```javascript
            NavTabHelper.updateSingleNavTabDetailsWithPath(royalty_account_id, {
              path,
              name,
              value,
              nvps,
              primaryKey,
              kVal,
            },
              async () => {
                await AccountsService.modify({
                  ...payload,
                })
              }
            ); 
          ```

          This is necessary to ensure consistency in the application.
       */
      const updateSingleNavTabDetailsWithPath = (primaryKeyValue, pathParams, databaseUpdateFuntion) => {
        const {
          path,
          name,
          value,
          nvps,
          primaryKey,
          kVal,
          noDatabaseUpdate,
        } = pathParams;
        console.log({ 'nav-tab.js:270 pathParams': pathParams });
        console.log({
          'nav-tab.js:272 detailsGetterKey': detailsGetterKey,
          primaryKeyValue,
          'getters?.[detailsGetterKey]?.[primaryKeyValue]': getters?.[detailsGetterKey]?.[primaryKeyValue]
        });

        if (!path) {
          throw Error('Path is required');
        }DetailsAction.SET.ALL

        if (!databaseUpdateFuntion) {
          throw new Error(`The 'databaseUpdateFuntion' parameter is required. It's the third Parameter. Please provide a function, even if it's empty. For example:

          async () => {
            await Service.api(payload);
          }

          This is necessary to ensure consistency in the application.`);
        }

        if (primaryKey && !kVal) {
          throw Error('kVal is required when primaryKey is provided');
        }

        if (kVal && !primaryKey) {
          throw Error('primaryKey is required when kVal is provided');
        }

        if (!name) {
          throw Error('Name is required');
        }

        if (typeof value === 'undefined') {
          throw Error('Value is required');
        }

        if (!getters?.[detailsGetterKey]?.[primaryKeyValue]) {
          return;
        }

        const detailsObject = getters[detailsGetterKey][primaryKeyValue];

        dispatch(DetailsAction.SET.ALL, {
          ...getters[detailsGetterKey],
          [primaryKeyValue]: {
            ...getters[detailsGetterKey][primaryKeyValue],
            ...(primaryKey && Array.isArray(detailsObject[path]) ? {
              [path]: detailsObject[path].map(e => {
                if (`${e[primaryKey]}` === `${kVal}`) {
                  return {
                    ...e,
                    [name]: value,
                    ...(isValidKeyValuePairs(nvps) ? fromPairs(nvps) : {})
                  };
                }
                return e;
              })
            } : {
              [path]: {
                ...detailsObject[path],
                [name]: value
              }
            }),
          },
        });

        if (!noDatabaseUpdate) {
          databaseUpdateFuntion();
        }
      }
      /**
       * First checks if the SingleNavTabObject exists in the NavTabDict. If it does, Find the Single NavTabDetails by the Primary Key Value and then Update it by the Update Function (the original Object is passed as the first argument)
       * @param  {string} primaryKeyValue='123'
       * @param  {(original)=>update} updateFunc=(original)=>update
       */
      const updateSingleNavTabDetailsIfExist = (primaryKeyValue, updateFunc = (() => { })) => {
        if (getters[detailsGetterKey][primaryKeyValue]) {
          updateSingleNavTabDetails(primaryKeyValue, updateFunc);
        }
      }
      /**
       * Set the new Value of the Single NavTabObject by the Setter Function.
       * Setter Function takes the Details Dict and the oldSingleDetails as arguments.
       * Spread the return Object if necessary, it does not update the Single Details. It directly Sets the value.
       * @param  {string} primaryKeyValue
       * @param  {(detailsDict, oldSingleDetails) => newSingleDetails} setFunc=(detailsDict, oldSingleDetails) => newSingleDetails
       */
      const setSingleNavTabDetails = (primaryKeyValue, setFunc = (detailsDict, oldSingleDetails) => newSingleDetails) => {
        const singleDetails = setFunc(getters?.[detailsGetterKey], getters?.[detailsGetterKey]?.[primaryKeyValue]);

        // Setting the Nav Tab Date so that in the Tab UI the list can be sorted
        if (!getters?.[detailsGetterKey]?.[primaryKeyValue] && singleDetails && (typeof singleDetails == 'object')) {
          singleDetails[NAV_TAB_DATE] = new Date();
        }


        dispatch(DetailsAction.SET.ALL, {
          ...getters[detailsGetterKey],
          [primaryKeyValue]: singleDetails,
        });
      }

      /**
       * Removes the Single NavTabDetails by the primary key value.
       * Call it either after deleting the Object from the List
       * OR if you just want to clear and close the Sidewindow.
       * This only clears the Data.
       * @param {string} primaryKeyValue 
       */
      const clearSingleNavTabDetails = (primaryKeyValue) => {
        dispatch(DetailsAction.SET.ALL, {
          ...getters[detailsGetterKey],
          [primaryKeyValue]: undefined
        });
      }


      /**
       * gets the Single Details Object from the NavTabDetails Dictionary object by the primary Key value
       * @param  {string} primaryKey
       */
      const getSingDet = (primaryKeyValue) => {
        return getters[detailsGetterKey][primaryKeyValue];
      }
      return {
        updateSingleNavTabDetails,
        updateSingleNavTabDetailsWithPath,
        updateSingleNavTabDetailsIfExist,
        getSingDet,
        setSingleNavTabDetails,
        clearSingleNavTabDetails,
      }
    },

    implementDeleteNavTabAction,
    implementSetAllNavTabDetailsAction,

    implementActions,
  }

}

export const setNavigationTabs = (commit, rootState, moduleRoute = 'booking', childRoute = 'booking_list', tabs) => {
  commit(AppActionTypes.SET_APP_NAV_ITEMS, rootState.app.appNavItems.map(module => {
    if (module.route == moduleRoute) {
      return {
        ...module,
        children: module.children.map(sub => {
          if (sub.route == childRoute) {
            return {
              ...sub,
              children: tabs
            }
          } else {
            return sub;
          }
        })
      }
    } else {
      return module;
    }
  }), { root: true });
}

export const getTabsFromDetailsDict = (detailsDict, createTabObjectFunc = createTabObject) => {
  return toPairs(detailsDict)
    .sort((a, b) => {

      if (a?.[1]?.[NAV_TAB_DATE] > b?.[1]?.[NAV_TAB_DATE]) {
        return -1;
      } else {
        return 1;
      }
    })
    .map(([key, value]) => {
      return value ? { route: key, ...createTabObjectFunc(value, key) } : undefined;
    }).filter(e => e);
}

/** Creates the Tab Object. Second argument is passed on in the execution time  - The Key of the Details Dict. Use it to set the optoinal title*/
export const createTabObject = ({
  title = '',
  full_title = ''
}, key) => {
  return {
    title,
    full_title,
  }
}




export const handleCloseTab = (store, item, subItem, details) => {

  const action = `${item.store}/${subItem.DetailsAction.DELETE.SINGLE}`;
  const payload = {
    [subItem.primaryKey]: details.route
  };

  if (action && payload) {
    store.dispatch(action, payload);
  }

}


export const handleCloseTabRoute = (childRoute = 'notices/client_notice_id', listRoute = 'notices', primaryKey = 'client_notice_id', keyValue, router) => {
  if (matchHead(childRoute, router.currentRoute.name)) {
    if (router.currentRoute.params[primaryKey] == keyValue) {
      router.push({
        name: listRoute
      });
    }
  }
}


export const setDetailsObject = (dispatch, DetailsActionTypeObject = NoticesDetails, getters, getterKey = 'noticesDetails', detailsKey) => {
  dispatch(DetailsActionTypeObject.SET.ALL, {
    ...getters[getterKey],
    [detailsKey]: undefined
  });
}



function isValidKeyValuePairs(array) {
  // Check if input is an array
  if (!Array.isArray(array)) {
    return false;
  }

  // Check each element in the array
  for (let i = 0; i < array.length; i++) {
    const pair = array[i];

    // Check if element is an array with 2 elements
    if (!Array.isArray(pair) || pair.length !== 2) {
      return false;
    }

    // Check if first element of pair is a string
    if (typeof pair[0] !== 'string') {
      return false;
    }
  }

  // If all checks pass, return true
  return true;
}